import { createAction, props } from '@ngrx/store';

export const registerLayout = createAction(
  '[Layout] Register Layout',
  props<any>()
);

export const unregisterLayout = createAction(
  '[Layout] Unregister Layout',
  props<any>()
);

export const updateResolutionLayout = createAction(
  '[Layout] Update Resolution of Layout',
  props<any>()
);
